import axios from 'axios'

export default {
    invite(emails) {
        return axios.post('/web-api/send-user-invites', {
            emails: emails
        })
    },

    inviteFriend(id, channelId) {
        return axios.post('/web-api/invite-friend', {
            user_id: id,
            channel_id: channelId
        })
    }
}
